<template>
  <div>
    <document-info-card
      title="My Documents"
      :data="[]"
      documentIndex=""
      documentClassifications="documentClassifications"
    ></document-info-card>
  </div>
</template>

<script>
import axios from "axios";
import DocumentInfoCard from "../DocumentInfoCard.vue";
import { mapGetters } from "vuex";

export default {
  name: "Documents",
  components: {
    DocumentInfoCard,
  },
  data() {
    return {
      documentClassifications: [],
      myDocuments: [],
      loading: false,
      create_error: null,
      get_error: null,
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },
  methods: {
    async fetchData() {
      try {
        await Promise.all([
          this.getMyDocuments(),
          this.getDocumentClassifications(),
        ]);
      } catch (error) {
        console.error(error);
      }
    },

    async getMyDocuments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      try {
        const response = await axios.get(
          `${this.getOrganization}/employee/${this.getCurrentEmployeeId}/document/${this.$ApiVersion}/request`,
          options
        );

        if (response.data.StatusCode === 200) {
          this.myDocuments = response.data.Data;
        } else {
          this.create_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.create_error = error.message;
      } finally {
        this.loading = false;
      }
    },

    async getDocumentClassifications() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.get(
          `${this.getOrganization}/setup/document/classification/${this.$ApiVersion}/request`,
          options
        );

        if (response.data.StatusCode === 200) {
          this.documentClassifications = response.data.Data;
        } else {
          this.get_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.get_error = error.message;
      } finally {
        this.loading = false;
      }
    },

    getDocumentsByClassification(classification) {
      return this.myDocuments.filter(
        (doc) => doc.DocumentClassification === classification
      );
    },
  },
};
</script>
